// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1XTTe","colMin":"styles_colMin__2G2I9","colCheckbox":"styles_colCheckbox__243Il"};